<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="audioTranscriptionModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total" v-if="instaciavel">
                    <div class="modal-header">
                        <h5 class="modal-title">Assistente IA: Transcrição</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <audio-transcription-recorder ref="atr" :atendimento="atendimento" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-primary">Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; 
import AudioTranscriptionRecorder from './AudioTranscriptionRecorder.vue'

export default {
    data() {
        return { 
            instaciavel: false
        }
    },

    props: [
        'atendimento'
    ],

    components: {
        AudioTranscriptionRecorder,
    },
    
    methods: { 
        abrir () { 
            this.instaciavel = true; 

            $('#audioTranscriptionModal').modal('show'); 
        }
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.modal-dialog3 {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100%;
  max-height: 100% !important;
}
</style>
